import { Controller } from '@hotwired/stimulus';

// Tooltip для серверного "Price history" SVG на /prices сторінках. Увесь
// контент уже в DOM (SEO-контракт) — тут лише показ тултіпа з data-атрибутів
// hit-кола. Патерн 1:1 з mileage_chart_controller.
export default class extends Controller {
  static targets = ['hit', 'tooltip'];

  // Дані з батчу, але тултіп все одно будуємо textContent-ом, не innerHTML.
  showTip(event) {
    const d = event.currentTarget.dataset;
    const tip = this.tooltipTarget;
    tip.textContent = '';
    const title = document.createElement('strong');
    title.textContent = d.label;
    const line = document.createElement('div');
    line.textContent = d.average
      ? `${d.average} average asking price`
      : `${d.median} median · ${d.range} typical · ${d.count} cars`;
    tip.append(title, line);
    tip.hidden = false;
    const plot = tip.parentElement.getBoundingClientRect();
    const dot = event.currentTarget.getBoundingClientRect();
    const scroll = tip.parentElement.scrollLeft || 0;
    const halfWidth = tip.getBoundingClientRect().width / 2;
    const center = Math.max(halfWidth + 8, Math.min(plot.width - halfWidth - 8, dot.left - plot.left + dot.width / 2));
    tip.style.left = `${center + scroll}px`;
    tip.style.top = `${Math.max(tip.getBoundingClientRect().height + 8, dot.top - plot.top - 10)}px`;
  }

  navigate(event) {
    if (event.key === 'Escape') return this.hideTip();
    if (['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      return this.showTip(event);
    }
    const index = this.hitTargets.indexOf(event.currentTarget);
    let next;
    if (event.key === 'ArrowRight') next = Math.min(index + 1, this.hitTargets.length - 1);
    if (event.key === 'ArrowLeft') next = Math.max(index - 1, 0);
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = this.hitTargets.length - 1;
    if (next === undefined) return;
    event.preventDefault();
    this.hitTargets.forEach((hit, i) => { hit.tabIndex = i === next ? 0 : -1; });
    this.hitTargets[next].focus();
  }

  hideTip() {
    this.tooltipTarget.hidden = true;
  }
}
